// extracted by mini-css-extract-plugin
export var deleteModal = "_rj-0";